<template>
    <div v-if="isLoaded">
        <div class="content-body"
             v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card"
                         style="">
                        <div class="card-header">
                            <h4 class="card-title">Consulta Docs</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"
                                   @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"
                                 v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onStatusMensageria(null, false)"
                                           v-b-tooltip.hover.left="'Mensageria'"
                                           v-if="getPermission('cte.reenvio.mensageria')"><i class="ft-check"></i></a></li>
                                    <li><a @click="onAcaoDoc('2')"
                                           v-b-tooltip.hover.left="'Cancelar'"
                                           v-if="getPermission('cte.evento')"><i class="ft-x-circle"></i></a></li>
                                    <!-- <li><a @click="onAcaoDoc('3')"
                                           v-b-tooltip
                                           title="Inutilizar"
                                           v-if="getPermission('cte.evento')"><i class="ft-x-square"></i></a></li> -->
                                    <li><a @click="onImprimirPorNfe()"
                                           v-b-tooltip
                                           title="Imprimir por chave NFe"><i class="ft-printer"></i></a></li>
                                    <li><a @click="onImprimirXml(null, 3)"
                                           v-b-tooltip
                                           title="Imprimir Documentos em lote compactado"><i class="ft-printer"></i></a></li>
                                    <li><a @click="onDownloadXmlLote()"
                                           v-b-tooltip
                                           title="Imprimir XML em lote compactado"><i class="ft-printer"></i></a></li>
                                    <li><a @click="onImprimirEtiqueta()"
                                           v-b-tooltip
                                           title="Imprimir Etiqueta"
                                           v-if="getPermission('cte.imprimir.etiqueta')"><i class="ft-printer"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Expande a tela"
                                           v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Minimiza a tela"
                                           v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()"
                                           v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                     <div>
                                      <a
                                        @click="searchAll()"
                                        v-b-tooltip
                                        title="Selecionar todas as páginas"
                                        v-if="getPermissionFw('gerardoc.store')"
                                        ><i
                                          class="fa fa-check-square-o fa-lg"
                                          style="margin: 0px 0px 5px 4px"
                                        ></i
                                      ></a>
                                    </div>
                                    <vuetable ref="vuetable"
                                              api-url="/api/cte"
                                              :fields="fields"
                                              :css="css"
                                              :append-params="moreParams"
                                              track-by="doc_id"
                                              pagination-path=""
                                              @vuetable:pagination-data="onPaginationData"
                                              @vuetable:cell-clicked="onDetail"
                                              @vuetable:loaded="onLoaded"
                                              detail-row-component="cte-detalhes">

                                      <template slot="status" slot-scope="props">
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==6">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==8">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.status.valor==5">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.status.valor==7">{{ props.rowData.status.descr }}</span>
                                        </template>

                                    <template slot="tp_evento" slot-scope="props">
                                        <div style="display: flex">
                                            <span class="badge badge-secondary" v-if="props.rowData.tp_evento.valor==1">{{ props.rowData.tp_evento.descr }}</span>
                                            <span class="badge badge-warning" v-if="props.rowData.tp_evento.valor==2">{{ props.rowData.tp_evento.descr }}</span>
                                            <span class="badge badge-info" v-if="props.rowData.tp_evento.valor==3">{{ props.rowData.tp_evento.descr }}</span>
                                            <span class="badge badge-success" v-if="props.rowData.tp_evento.valor==4">{{ props.rowData.tp_evento.descr }}</span>
                                            <div v-if="props.rowData.doc_cte">
                                                <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_mensageria.valor==1" v-b-tooltip title="Status Mensageria Pendente">P</span><span class="badge badge-info" v-if="props.rowData.doc_cte.status_mensageria.valor==2" v-b-tooltip title="Status Mensageria Enviado">E</span><span class="badge badge-success" v-if="props.rowData.doc_cte.status_mensageria.valor==3" v-b-tooltip title="Status Mensageria Recebido">R</span>
                                            </div>
                                        </div>
                                      </template>

                                      <template slot="remetente" slot-scope="props">
                                        <div>
                                           {{ props.rowData.doc_cte_partes_env.rem_nome }} - {{ props.rowData.doc_cte_partes_env.rem_cnpj }}
                                        </div>
                                      </template>

                                      <template slot="tp_doc" slot-scope="props">
                                        <div v-if="props.rowData.tp_doc.valor == 1 && props.rowData.doc_cte.tp_cte.descr">
                                           {{ props.rowData.doc_cte.tp_cte.descr }}
                                        </div>

                                        <div v-if="props.rowData.tp_doc.valor == 2 && props.rowData.doc_rps.tp_rps.descr">
                                          {{ props.rowData.doc_rps.tp_rps.descr }}
                                        </div>
                                      </template>


                                      <template slot="status_sefaz" slot-scope="props">
                                        <div v-if="props.rowData.doc_cte">
                                          <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_sefaz.valor==1">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-secondary" v-if="props.rowData.doc_cte.status_sefaz.valor==2">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.doc_cte.status_sefaz.valor==3">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.doc_cte.status_sefaz.valor==4">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==5">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==6">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==7">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.doc_cte.status_sefaz.valor==8">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.doc_cte.status_sefaz.valor==9">{{ props.rowData.doc_cte.status_sefaz.descr }}</span>
                                        </div>
                                      </template>

                                      <template slot="tp_processo" slot-scope="props">
                                        <div>
                                          <span class="badge badge-warning" v-if="props.rowData.tp_processo.valor==1">{{ props.rowData.tp_processo.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.tp_processo.valor==2">{{ props.rowData.tp_processo.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.tp_processo.valor==3">{{ props.rowData.tp_processo.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.tp_processo.valor==4">{{ props.rowData.tp_processo.descr }}</span>
                                          <span class="badge badge-light" v-if="props.rowData.tp_processo.valor==5">{{ props.rowData.tp_processo.descr }}</span>
                                          <span class="badge badge-secondary" v-if="props.rowData.tp_processo.valor==6">{{ props.rowData.tp_processo.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.tp_processo.valor==7">{{ props.rowData.tp_processo.descr }}</span>
                                        </div>
                                      </template>

                                      <template slot="tp_operacao" slot-scope="props">
                                        <div>
                                          <span class="badge badge-warning" v-if="props.rowData.tp_operacao.valor==1">{{ props.rowData.tp_operacao.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.tp_operacao.valor==2">{{ props.rowData.tp_operacao.descr }}</span>
                                          <span class="badge badge-secondary" v-if="props.rowData.tp_operacao.valor==3">{{ props.rowData.tp_operacao.descr }}</span>
                                        </div>
                                      </template>

                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">

                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            <span>
                                                <a @click="onStatusMensageria(props.rowData, true)" v-b-tooltip title="Mensageria"><i class="fa fa-check"></i></a>
                                            </span>

                                            <span>
                                                <span>
                                                    <a @click="onImprimirRps(props.rowData.doc_id, props.rowData.tp_doc.valor)" v-if="props.rowData.doc_rps!=null" v-b-tooltip title="Imprimir RPS"><i class="fa fa-download"></i></a>
                                                </span>
                                            </span>
                                            
                                            <div v-if="props.rowData.tp_doc.valor==1">
                                              <span v-if="getPermission('cte.carta.store')">
                                                  <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                      <a @click="onCreateCarta(props.rowData)" v-if="props.rowData.tp_evento.valor==1" v-b-tooltip title="Gerar Carta de Correção"><i class="fa fa-file-o"></i></a>
                                                  </span>
                                              </span>

                                              <!-- <span v-if="getPermission('cte.update')">
                                                  <a @click="onEdit(props.rowData)" v-if="props.rowData.doc_cte.status_sefaz.valor==5||props.rowData.doc_cte.status_sefaz.valor==9" v-b-tooltip title="Editar CTE"><i class="fa fa-edit"></i></a>
                                              </span> -->

                                              <span v-if="getPermission('cte.update')">
                                                  <a @click="onEdit(props.rowData)" v-if="props.rowData.doc_cte.status_sefaz.valor==5||props.rowData.doc_cte.status_sefaz.valor==9" v-b-tooltip title="Editar Partes envolvidas CTE"><i class="fa fa-edit"></i></a>
                                              </span>

                                              <span v-if="getPermission('cte.complementar.store')">
                                                  <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                      <a @click="onCreateComplementar(props.rowData)" v-if="props.rowData.tp_evento.valor==1" v-b-tooltip title="Gerar CTE Complementar"><i class="fa fa-tasks"></i></a>
                                                  </span>
                                              </span>
                                              <span v-if="getPermission('cte.imprimir')">
                                                  <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                      <a @click="onImprimirXml(props.rowData.doc_id, 1, props.rowData.tp_doc.valor)" v-if="props.rowData.doc_cte.doc_cte_xml.length>0" v-b-tooltip title="Imprimir Dacte"><i class="fa fa-download"></i></a>
                                                  </span>
                                              </span>
                                              <span v-if="getPermission('cte.imprimir')">
                                                  <span v-if="props.rowData.doc_cte.status_sefaz.valor==4 || props.rowData.doc_cte.status_sefaz.valor==7">
                                                      <a @click="onDownloadXml(props.rowData.doc_cte.doccte_id, null)" v-if="props.rowData.doc_cte.doc_cte_xml.length>0 || props.rowData.doc_cte.doc_cte_xml.length > 0" v-b-tooltip title="Download XML"><i class="fa fa-code"></i></a>
                                                  </span>
                                              </span>
                                              <span v-if="getPermission('cte.complementar.store')">
                                                  <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                      <a @click="onCreateCteAnulacao(props.rowData.doc_id)" v-if="props.rowData.tp_evento.valor==1" v-b-tooltip title="Gerar CTE Anulação"><i class="fa fa-compress"></i></a>
                                                  </span>
                                              </span>

                                              <span v-if="getPermission('cte.complementar.store')">
                                                  <span v-if="props.rowData.doc_cte.status_sefaz.valor==4">
                                                      <a @click="onCteSubstituto(props.rowData.doc_id, props.rowData.doc_cte_partes_env.tom_tomador)" v-if="props.rowData.tp_evento.valor==1" v-b-tooltip title="Gerar CTE Substituto"><i class="fa fa-share"></i></a>
                                                  </span>
                                              </span>
                                            </div>
                                            <div v-if="props.rowData.tp_doc.valor==2">
                                              <span v-if="getPermission('cte.imprimir')">
                                                  <span>
                                                      <a @click="onDownloadXml(null, props.rowData.doc_rps.docrps_id)" v-if="props.rowData.doc_rps.doc_rps_xml.length>0" v-b-tooltip title="Download XML"><i class="fa fa-code"></i></a>
                                                  </span>
                                              </span>
                                            </div>
                                            

                                          </button>
                                        </div>
                                      </template>
                                  </vuetable>
                                </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_form_cderp"
                     ref="modal_form_cderp"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalErp"
                     @ok="handleOkCdErp">

               <form @submit.stop.prevent="handleOkCdErp" @keydown="formerp.errors.clear($event.target.name)">
                   <label>Código</label>
                   <b-form-input type="text"
                                 placeholder="Código"
                                 v-model="formerp.cd"
                                 name="cd"
                                 >
                   </b-form-input>
                   <b-form-feedback v-text="formerp.errors.get('cd')" v-if="formerp.errors.has('cd')"></b-form-feedback>
               </form>
                      <div slot="modal-footer" class="w-100">
                             <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                             <div class="float-right">
                                 <b-btn @click="showModalErp=false" variant="secondary">
                                   Fechar
                                 </b-btn>
                                 <b-btn @click="handleOkCdErp($event)" variant="secondary" :disabled="isDisabled">
                                   Enviar
                                 </b-btn>
                             </div>
                      </div>
                  </b-modal>
            <!-- Modal Component -->
            <b-modal id="modal_form_enviar_xml_dacte"
                     ref="modal_form_enviar_xml_dacte"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     cancel-title="Cancelar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalEnviarXmlDacte"
                     @ok="handleOkEnviarXmlDacte">

                  <form @submit.stop.prevent="handleOkEnviarXmlDacte" @keydown="form_enviar_xml.errors.clear($event.target.name)">
                     <label>Email</label>
                     <b-form-input type="text"
                                   placeholder="Email"
                                   v-model="form_enviar_xml.email"
                                   name="email"
                                   >
                     </b-form-input>
                     <b-form-feedback v-text="form_enviar_xml.errors.get('email')" v-if="form_enviar_xml.errors.has('email')"></b-form-feedback>
                  </form>
                        <div slot="modal-footer" class="w-100">
                               <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                               <div class="float-right">
                                   <b-btn @click="showModalEnviarXmlDacte=false" variant="secondary">
                                     Fechar
                                   </b-btn>
                                   <b-btn @click="handleOkEnviarXmlDacte($event)" variant="secondary" :disabled="isDisabled">
                                     Enviar
                                   </b-btn>
                               </div>
                        </div>
                    </b-modal>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModal"
                     :ok-disabled=formdoc.errors.any()
                     @ok="handleAcaoDoc">
                    <form @submit.stop.prevent="handleAcaoDoc" @keydown="formdoc.errors.clear($event.target.name)">
                        Total de CTE(s) selecionado(s): {{ this.formdoc.doc_id.length }}
                      <b-container fluid class="p-a-0">
                        <b-row>
                          <b-col>
                              <label>Motivo</label>
                              <multiselect v-model="formdoc.motivo"
                              :options="optionsParamMotivo"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="formdoc.errors.get('motivo')" v-if="formdoc.errors.has('motivo')"></b-form-feedback>
                            </b-col>
                          </b-row>
                        </b-container>
                        <label>Observação</label>

                        <b-form-textarea name="obs"
                                         v-model="formdoc.obs"
                                         placeholder="Observação"
                                         :rows="6"
                                         :max-rows="6">
                        </b-form-textarea>
                        <b-form-feedback class="text-danger" v-text="formdoc.errors.get('obs')" v-if="formdoc.errors.has('obs')"></b-form-feedback>

                        * As regras para efetuar a operação são aplicadas mesmo com CTE's multiplos selecionados
                    </form>

                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Enviando..."></spinner></div>
                           <div class="float-right">
                               <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                               <b-btn @click="showModal=false" variant="secondary">
                                 Cancelar
                               </b-btn>
                               <b-btn @click="handleAcaoDoc($event)" variant="secondary" :disabled="isDisabled">
                                 {{ this.modal_titulo }}
                               </b-btn>
                           </div>
                    </div>
                </b-modal>
            <b-modal id="modal_form_carta"
                     ref="modal_form_carta"
                     size="lg"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModalCarta"
                     :ok-disabled=form.errors.any()
                     @ok="handleOkCarta">
                    <form @submit.stop.prevent="handleOkCarta" @keydown="form.errors.clear($event.target.name)">
                        <b-container fluid class="p-a-0">
                            <b-row>
                                <b-col>
                                    <label>Produto Predominante</label>
                                    <b-form-input type="text"
                                                placeholder="Produto Predominante"
                                                v-model="form.produto_predominante"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('produto_predominante')" v-if="form.errors.has('produto_predominante')"></b-form-feedback>
                                </b-col>
                                <b-col>
                                    <label>Valor Carga</label>
                                    <currency-input
                                                        class="form-control"
                                                        v-model="form.vlr_carga"
                                                        :auto-decimal-mode="true"
                                                        :precision="4"
                                                        placeholder="Valor Carga"
                                                        :currency="{ prefix: '' }"
                                                        :distraction-free="getCurrency"
                                                      />
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_carga')" v-if="form.errors.has('vlr_carga')"></b-form-feedback>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <label>Observação interna da Carta</label>
                                    <b-form-textarea id="textarea1"
                                                     name="obs"
                                                     v-model="form.obs_carta"
                                                     placeholder="Observação interna para a Carta"
                                                     :rows="3"
                                                     :max-rows="3">
                                    </b-form-textarea>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('obs_carta')" v-if="form.errors.has('obs_carta')"></b-form-feedback>
                                </b-col>
                            </b-row>
                        </b-container>
                        <b-container fluid class="p-a-0">
                          <b-row>
                            <b-col>
                                <br/>
                                <h3 class="panel-title">Detalhes do CTE para Carta </h3>
                                <b-tabs>
                                  <b-tab title="Partes Envolvidas" active>
                                    <b-tabs>
                                      <b-tab title="Expedidor" active>
                                      <b-row>
                                        <b-col>
                                            <label>Nome</label>
                                            <b-form-input type="text"
                                                        placeholder="Nome"
                                                        v-model="form.doc_cte_partes_env.exp_nome"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_nome==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_nome')" v-if="form.errors.has('exp_nome')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>CNPJ</label>
                                            <b-form-input type="text"
                                                        placeholder="CNPJ"
                                                        disabled
                                                        v-model="form.doc_cte_partes_env.exp_cnpj"
                                                        name="cst"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_cnpj')" v-if="form.errors.has('exp_cnpj')"></b-form-feedback>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-col>
                                            <label>Inscrição Estadual</label>
                                            <b-form-input type="text"
                                                        placeholder="Inscrição Estadual"
                                                        disabled
                                                        v-model="form.doc_cte_partes_env.exp_ie"
                                                        name="cst"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_ie')" v-if="form.errors.has('exp_ie')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>CPF</label>
                                            <b-form-input type="text"
                                                        placeholder="CPF"
                                                        disabled
                                                        v-model="form.doc_cte_partes_env.exp_cpf"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_cpf==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_cpf')" v-if="form.errors.has('exp_cpf')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Nome Fantasia</label>
                                            <b-form-input type="text"
                                                        placeholder="Nome Fantasia"
                                                        v-model="form.doc_cte_partes_env.exp_nome_fantasia"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_nome_fantasia==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_nome_fantasia')" v-if="form.errors.has('exp_nome_fantasia')"></b-form-feedback>
                                        </b-col>
                                        </b-row>
                                        <hr>
                                        <div class="tbl-row">
                                            <div class="tbl-cell tbl-cell-title">
                                                <h5>Endereço</h5>
                                            </div>
                                        </div>
                                        <b-row>
                                          <b-col>
                                              <label>CEP</label>
                                              <b-form-input type="text"
                                                          placeholder="CEP"
                                                          v-model="form.doc_cte_partes_env.exp_cep"
                                                          name="cep"
                                                          :disabled="form.doc_cte_partes_env.exp_cep==null"
                                                          >
                                              </b-form-input>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('exp_cep')" v-if="form.errors.has('exp_cep')"></b-form-feedback>
                                          </b-col>
                                        <b-col>
                                            <label>Rua</label>
                                            <b-form-input type="text"
                                                        placeholder="Rua"
                                                        v-model="form.doc_cte_partes_env.exp_endereco"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_endereco==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_endereco')" v-if="form.errors.has('exp_endereco')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Número</label>
                                            <b-form-input type="text"
                                                        placeholder="Número"
                                                        v-model="form.doc_cte_partes_env.exp_numero"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_numero==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_numero')" v-if="form.errors.has('exp_numero')"></b-form-feedback>
                                        </b-col>
                                        </b-row>
                                        <b-row>
                                        <b-col>
                                            <label>Bairro</label>
                                            <b-form-input type="text"
                                                        placeholder="Bairro"
                                                        v-model="form.doc_cte_partes_env.exp_bairro"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_bairro==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_bairro')" v-if="form.errors.has('exp_bairro')"></b-form-feedback>
                                        </b-col>
                                        <b-col>
                                            <label>Complemento</label>
                                            <b-form-input type="text"
                                                        placeholder="Complemento"
                                                        v-model="form.doc_cte_partes_env.exp_complemento"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_complemento==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_complemento')" v-if="form.errors.has('exp_complemento')"></b-form-feedback>
                                        </b-col>
                                        </b-row>
                                        <b-row>
                                          <b-col>
                                              <label>Município</label>
                                              <b-form-input type="text"
                                                          placeholder="Município"
                                                          disabled
                                                          v-model="form.doc_cte_partes_env.exp_nome_municipio"
                                                          name="cst"
                                                          >
                                              </b-form-input>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('exp_nome_municipio')" v-if="form.errors.has('exp_nome_municipio')"></b-form-feedback>
                                          </b-col>
                                        <b-col>
                                            <label>UF</label>
                                            <b-form-input type="text"
                                                        placeholder="UF"
                                                        disabled
                                                        v-model="form.doc_cte_partes_env.exp_uf"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.exp_uf==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('exp_uf')" v-if="form.errors.has('exp_uf')"></b-form-feedback>
                                        </b-col>
                                      </b-row>
                                      <b-row>
                                      <b-col>
                                          <label>Email</label>
                                          <b-form-input type="text"
                                                      placeholder="Email"
                                                      v-model="form.doc_cte_partes_env.exp_email"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.exp_email==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('exp_email')" v-if="form.errors.has('exp_email')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                          <label>Telefone</label>
                                          <b-form-input type="text"
                                                      placeholder="Telefone"
                                                      v-model="form.doc_cte_partes_env.exp_telefone"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.exp_telefone==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('exp_telefone')" v-if="form.errors.has('exp_telefone')"></b-form-feedback>
                                      </b-col>
                                    </b-row>
                                  </b-tab>
                                  <b-tab title="Recebedor">
                                    <b-row>
                                      <b-col>
                                          <label>Nome</label>
                                          <b-form-input type="text"
                                                      placeholder="Nome"
                                                      v-model="form.doc_cte_partes_env.rec_nome"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_nome==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_nome')" v-if="form.errors.has('rec_nome')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                          <label>CNPJ</label>
                                          <b-form-input type="text"
                                                      placeholder="CNPJ"
                                                      disabled
                                                      v-model="form.doc_cte_partes_env.rec_cnpj"
                                                      name="cst"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_cnpj')" v-if="form.errors.has('rec_cnpj')"></b-form-feedback>
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                      <b-col>
                                          <label>Inscrição Estadual</label>
                                          <b-form-input type="text"
                                                      placeholder="Inscrição Estadual"
                                                      disabled
                                                      v-model="form.doc_cte_partes_env.rec_ie"
                                                      name="cst"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_ie')" v-if="form.errors.has('rec_ie')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                          <label>CPF</label>
                                          <b-form-input type="text"
                                                      placeholder="CPF"
                                                      disabled
                                                      v-model="form.doc_cte_partes_env.rec_cpf"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_cpf==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_cpf')" v-if="form.errors.has('rec_cpf')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                          <label>Nome Fantasia</label>
                                          <b-form-input type="text"
                                                      placeholder="Nome Fantasia"
                                                      v-model="form.doc_cte_partes_env.rec_nome_fantasia"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_nome_fantasia==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_nome_fantasia')" v-if="form.errors.has('rec_nome_fantasia')"></b-form-feedback>
                                      </b-col>
                                      </b-row>
                                      <hr>
                                      <div class="tbl-row">
                                          <div class="tbl-cell tbl-cell-title">
                                              <h5>Endereço</h5>
                                          </div>
                                      </div>
                                      <b-row>
                                        <b-col>
                                            <label>CEP</label>
                                            <b-form-input type="text"
                                                        placeholder="CEP"
                                                        v-model="form.doc_cte_partes_env.rec_cep"
                                                        name="cst"
                                                        :disabled="form.doc_cte_partes_env.rec_cep==null"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('rec_cep')" v-if="form.errors.has('rec_cep')"></b-form-feedback>
                                        </b-col>
                                      <b-col>
                                          <label>Rua</label>
                                          <b-form-input type="text"
                                                      placeholder="Rua"
                                                      v-model="form.doc_cte_partes_env.rec_endereco"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_endereco==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_endereco')" v-if="form.errors.has('rec_endereco')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                          <label>Número</label>
                                          <b-form-input type="text"
                                                      placeholder="Número"
                                                      v-model="form.doc_cte_partes_env.rec_numero"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_numero==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_numero')" v-if="form.errors.has('rec_numero')"></b-form-feedback>
                                      </b-col>
                                      </b-row>
                                      <b-row>
                                      <b-col>
                                          <label>Bairro</label>
                                          <b-form-input type="text"
                                                      placeholder="Bairro"
                                                      v-model="form.doc_cte_partes_env.rec_bairro"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_bairro==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_bairro')" v-if="form.errors.has('rec_bairro')"></b-form-feedback>
                                      </b-col>
                                      <b-col>
                                          <label>Complemento</label>
                                          <b-form-input type="text"
                                                      placeholder="Complemento"
                                                      v-model="form.doc_cte_partes_env.rec_complemento"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_complemento==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_complemento')" v-if="form.errors.has('rec_complemento')"></b-form-feedback>
                                      </b-col>
                                      </b-row>
                                      <b-row>
                                        <b-col>
                                            <label>Município</label>
                                            <b-form-input type="text"
                                                        placeholder="Município"
                                                        disabled
                                                        v-model="form.doc_cte_partes_env.rec_nome_municipio"
                                                        name="cst"
                                                        >
                                            </b-form-input>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('rec_nome_municipio')" v-if="form.errors.has('rec_nome_municipio')"></b-form-feedback>
                                        </b-col>
                                      <b-col>
                                          <label>UF</label>
                                          <b-form-input type="text"
                                                      placeholder="UF"
                                                      disabled
                                                      v-model="form.doc_cte_partes_env.rec_uf"
                                                      name="cst"
                                                      :disabled="form.doc_cte_partes_env.rec_uf==null"
                                                      >
                                          </b-form-input>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('rec_uf')" v-if="form.errors.has('rec_uf')"></b-form-feedback>
                                      </b-col>
                                    </b-row>
                                    <b-row>
                                    <b-col>
                                        <label>Email</label>
                                        <b-form-input type="text"
                                                    placeholder="Email"
                                                    v-model="form.doc_cte_partes_env.rec_email"
                                                    name="cst"
                                                    :disabled="form.doc_cte_partes_env.rec_email==null"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('rec_email')" v-if="form.errors.has('rec_email')"></b-form-feedback>
                                    </b-col>
                                    <b-col>
                                        <label>Telefone</label>
                                        <b-form-input type="text"
                                                    placeholder="Telefone"
                                                    v-model="form.doc_cte_partes_env.rec_telefone"
                                                    name="cst"
                                                    :disabled="form.doc_cte_partes_env.rec_telefone==null"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('rec_telefone')" v-if="form.errors.has('rec_telefone')"></b-form-feedback>
                                    </b-col>
                                  </b-row>
                              </b-tab>
                              <b-tab title="Emitente">
                                <b-row>
                                  <b-col>
                                      <label>Nome</label>
                                      <b-form-input type="text"
                                                  placeholder="Nome"
                                                  v-model="form.doc_cte_partes_env.emi_nome"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_nome==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_nome')" v-if="form.errors.has('emi_nome')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <label>CNPJ</label>
                                      <b-form-input type="text"
                                                  placeholder="CNPJ"
                                                  disabled
                                                  v-model="form.doc_cte_partes_env.emi_cnpj"
                                                  name="cst"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_cnpj')" v-if="form.errors.has('emi_cnpj')"></b-form-feedback>
                                  </b-col>
                                </b-row>
                                <b-row>
                                  <b-col>
                                      <label>Inscrição Estadual</label>
                                      <b-form-input type="text"
                                                  placeholder="Inscrição Estadual"
                                                  disabled
                                                  v-model="form.doc_cte_partes_env.emi_ie"
                                                  name="cst"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_ie')" v-if="form.errors.has('emi_ie')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <label>CPF</label>
                                      <b-form-input type="text"
                                                  placeholder="CPF"
                                                  disabled
                                                  v-model="form.doc_cte_partes_env.emi_cpf"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_cpf==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_cpf')" v-if="form.errors.has('emi_cpf')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <label>Nome Fantasia</label>
                                      <b-form-input type="text"
                                                  placeholder="Nome Fantasia"
                                                  v-model="form.doc_cte_partes_env.emi_nome_fantasia"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_nome_fantasia==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_nome_fantasia')" v-if="form.errors.has('emi_nome_fantasia')"></b-form-feedback>
                                  </b-col>
                                  </b-row>
                                  <hr>
                                  <div class="tbl-row">
                                      <div class="tbl-cell tbl-cell-title">
                                          <h5>Endereço</h5>
                                      </div>
                                  </div>
                                  <b-row>
                                    <b-col>
                                        <label>CEP</label>
                                        <b-form-input type="text"
                                                    placeholder="CEP"
                                                    v-model="form.doc_cte_partes_env.emi_cep"
                                                    name="cst"
                                                    :disabled="form.doc_cte_partes_env.emi_cep==null"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('emi_cep')" v-if="form.errors.has('emi_cep')"></b-form-feedback>
                                    </b-col>
                                  <b-col>
                                      <label>Rua</label>
                                      <b-form-input type="text"
                                                  placeholder="Rua"
                                                  v-model="form.doc_cte_partes_env.emi_endereco"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_endereco==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_endeemio')" v-if="form.errors.has('emi_endeemio')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <label>Número</label>
                                      <b-form-input type="text"
                                                  placeholder="Número"
                                                  v-model="form.doc_cte_partes_env.emi_numero"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_numero==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_numero')" v-if="form.errors.has('emi_numero')"></b-form-feedback>
                                  </b-col>
                                  </b-row>
                                  <b-row>
                                  <b-col>
                                      <label>Bairro</label>
                                      <b-form-input type="text"
                                                  placeholder="Bairro"
                                                  v-model="form.doc_cte_partes_env.emi_bairro"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_bairro==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_bairro')" v-if="form.errors.has('emi_bairro')"></b-form-feedback>
                                  </b-col>
                                  <b-col>
                                      <label>Complemento</label>
                                      <b-form-input type="text"
                                                  placeholder="Complemento"
                                                  v-model="form.doc_cte_partes_env.emi_complemento"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_complemento==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_complemento')" v-if="form.errors.has('emi_complemento')"></b-form-feedback>
                                  </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col>
                                        <label>Município</label>
                                        <b-form-input type="text"
                                                    placeholder="Município"
                                                    disabled
                                                    v-model="form.doc_cte_partes_env.emi_nome_municipio"
                                                    name="cst"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('emi_nome_municipio')" v-if="form.errors.has('emi_nome_municipio')"></b-form-feedback>
                                    </b-col>
                                  <b-col>
                                      <label>UF</label>
                                      <b-form-input type="text"
                                                  placeholder="UF"
                                                  disabled
                                                  v-model="form.doc_cte_partes_env.emi_uf"
                                                  name="cst"
                                                  :disabled="form.doc_cte_partes_env.emi_uf==null"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('emi_uf')" v-if="form.errors.has('emi_uf')"></b-form-feedback>
                                  </b-col>
                                </b-row>
                                <b-row>
                                <b-col>
                                    <label>Email</label>
                                    <b-form-input type="text"
                                                placeholder="Email"
                                                v-model="form.doc_cte_partes_env.emi_email"
                                                name="cst"
                                                :disabled="form.doc_cte_partes_env.emi_email==null"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('emi_email')" v-if="form.errors.has('emi_email')"></b-form-feedback>
                                </b-col>
                                <b-col>
                                    <label>Telefone</label>
                                    <b-form-input type="text"
                                                placeholder="Telefone"
                                                v-model="form.doc_cte_partes_env.emi_telefone"
                                                name="cst"
                                                :disabled="form.doc_cte_partes_env.emi_telefone==null"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('emi_telefone')" v-if="form.errors.has('emi_telefone')"></b-form-feedback>
                                </b-col>
                              </b-row>
                          </b-tab>
                          <b-tab title="Remetente">
                            <b-row>
                              <b-col>
                                  <label>Nome</label>
                                  <b-form-input type="text"
                                              placeholder="Nome"
                                              v-model="form.doc_cte_partes_env.rem_nome"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_nome==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_nome')" v-if="form.errors.has('rem_nome')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>CNPJ</label>
                                  <b-form-input type="text"
                                              placeholder="CNPJ"
                                              disabled
                                              v-model="form.doc_cte_partes_env.rem_cnpj"
                                              name="cst"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_cnpj')" v-if="form.errors.has('rem_cnpj')"></b-form-feedback>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                  <label>Inscrição Estadual</label>
                                  <b-form-input type="text"
                                              placeholder="Inscrição Estadual"
                                              disabled
                                              v-model="form.doc_cte_partes_env.rem_ie"
                                              name="cst"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_ie')" v-if="form.errors.has('rem_ie')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>CPF</label>
                                  <b-form-input type="text"
                                              placeholder="CPF"
                                              disabled
                                              v-model="form.doc_cte_partes_env.rem_cpf"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_cpf==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_cpf')" v-if="form.errors.has('rem_cpf')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>Nome Fantasia</label>
                                  <b-form-input type="text"
                                              placeholder="Nome Fantasia"
                                              v-model="form.doc_cte_partes_env.rem_nome_fantasia"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_nome_fantasia==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_nome_fantasia')" v-if="form.errors.has('rem_nome_fantasia')"></b-form-feedback>
                              </b-col>
                              </b-row>
                              <hr>
                              <div class="tbl-row">
                                  <div class="tbl-cell tbl-cell-title">
                                      <h5>Endereço</h5>
                                  </div>
                              </div>
                              <b-row>
                                <b-col>
                                    <label>CEP</label>
                                    <b-form-input type="text"
                                                placeholder="CEP"
                                                v-model="form.doc_cte_partes_env.rem_cep"
                                                name="cst"
                                                :disabled="form.doc_cte_partes_env.rem_cep==null"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('rem_cep')" v-if="form.errors.has('rem_cep')"></b-form-feedback>
                                </b-col>
                              <b-col>
                                  <label>Rua</label>
                                  <b-form-input type="text"
                                              placeholder="Rua"
                                              v-model="form.doc_cte_partes_env.rem_endereco"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_endereco==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_enderemo')" v-if="form.errors.has('rem_enderemo')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>Número</label>
                                  <b-form-input type="text"
                                              placeholder="Número"
                                              v-model="form.doc_cte_partes_env.rem_numero"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_numero==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_numero')" v-if="form.errors.has('rem_numero')"></b-form-feedback>
                              </b-col>
                              </b-row>
                              <b-row>
                              <b-col>
                                  <label>Bairro</label>
                                  <b-form-input type="text"
                                              placeholder="Bairro"
                                              v-model="form.doc_cte_partes_env.rem_bairro"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_bairro==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_bairro')" v-if="form.errors.has('rem_bairro')"></b-form-feedback>
                              </b-col>
                              <b-col>
                                  <label>Complemento</label>
                                  <b-form-input type="text"
                                              placeholder="Complemento"
                                              v-model="form.doc_cte_partes_env.rem_complemento"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_complemento==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_complemento')" v-if="form.errors.has('rem_complemento')"></b-form-feedback>
                              </b-col>
                              </b-row>
                              <b-row>
                                <b-col>
                                    <label>Município</label>
                                    <b-form-input type="text"
                                                placeholder="Município"
                                                disabled
                                                v-model="form.doc_cte_partes_env.rem_nome_municipio"
                                                name="cst"
                                                >
                                    </b-form-input>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('rem_nome_municipio')" v-if="form.errors.has('rem_nome_municipio')"></b-form-feedback>
                                </b-col>
                              <b-col>
                                  <label>UF</label>
                                  <b-form-input type="text"
                                              placeholder="UF"
                                              disabled
                                              v-model="form.doc_cte_partes_env.rem_uf"
                                              name="cst"
                                              :disabled="form.doc_cte_partes_env.rem_uf==null"
                                              >
                                  </b-form-input>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rem_uf')" v-if="form.errors.has('rem_uf')"></b-form-feedback>
                              </b-col>
                            </b-row>
                            <b-row>
                            <b-col>
                                <label>Email</label>
                                <b-form-input type="text"
                                            placeholder="Email"
                                            v-model="form.doc_cte_partes_env.rem_email"
                                            name="cst"
                                            :disabled="form.doc_cte_partes_env.rem_email==null"
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('rem_email')" v-if="form.errors.has('rem_email')"></b-form-feedback>
                            </b-col>
                            <b-col>
                                <label>Telefone</label>
                                <b-form-input type="text"
                                            placeholder="Telefone"
                                            v-model="form.doc_cte_partes_env.rem_telefone"
                                            name="cst"
                                            :disabled="form.doc_cte_partes_env.rem_telefone==null"
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('rem_telefone')" v-if="form.errors.has('rem_telefone')"></b-form-feedback>
                            </b-col>
                          </b-row>
                      </b-tab>
                      <b-tab title="Tomador">
                        <b-row>
                          <b-col>
                              <label>Nome</label>
                              <b-form-input type="text"
                                          placeholder="Nome"
                                          v-model="form.doc_cte_partes_env.tom_nome"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_nome==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_nome')" v-if="form.errors.has('tom_nome')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>CNPJ</label>
                              <b-form-input type="text"
                                          placeholder="CNPJ"
                                          disabled
                                          v-model="form.doc_cte_partes_env.tom_cnpj"
                                          name="cst"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_cnpj')" v-if="form.errors.has('tom_cnpj')"></b-form-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                              <label>Inscrição Estadual</label>
                              <b-form-input type="text"
                                          placeholder="Inscrição Estadual"
                                          disabled
                                          v-model="form.doc_cte_partes_env.tom_ie"
                                          name="cst"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_ie')" v-if="form.errors.has('tom_ie')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>CPF</label>
                              <b-form-input type="text"
                                          placeholder="CPF"
                                          disabled
                                          v-model="form.doc_cte_partes_env.tom_cpf"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_cpf==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_cpf')" v-if="form.errors.has('tom_cpf')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>Nome Fantasia</label>
                              <b-form-input type="text"
                                          placeholder="Nome Fantasia"
                                          v-model="form.doc_cte_partes_env.tom_nome_fantasia"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_nome_fantasia==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_nome_fantasia')" v-if="form.errors.has('tom_nome_fantasia')"></b-form-feedback>
                          </b-col>
                          </b-row>
                          <hr>
                          <div class="tbl-row">
                              <div class="tbl-cell tbl-cell-title">
                                  <h5>Endereço</h5>
                              </div>
                          </div>
                          <b-row>
                            <b-col>
                                <label>CEP</label>
                                <b-form-input type="text"
                                            placeholder="CEP"
                                            v-model="form.doc_cte_partes_env.tom_cep"
                                            name="cst"
                                            :disabled="form.doc_cte_partes_env.tom_cep==null"
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('tom_cep')" v-if="form.errors.has('tom_cep')"></b-form-feedback>
                            </b-col>
                          <b-col>
                              <label>Rua</label>
                              <b-form-input type="text"
                                          placeholder="Rua"
                                          v-model="form.doc_cte_partes_env.tom_endereco"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_endereco==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_endetomo')" v-if="form.errors.has('tom_endetomo')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>Número</label>
                              <b-form-input type="text"
                                          placeholder="Número"
                                          v-model="form.doc_cte_partes_env.tom_numero"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_numero==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_numero')" v-if="form.errors.has('tom_numero')"></b-form-feedback>
                          </b-col>
                          </b-row>
                          <b-row>
                          <b-col>
                              <label>Bairro</label>
                              <b-form-input type="text"
                                          placeholder="Bairro"
                                          v-model="form.doc_cte_partes_env.tom_bairro"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_bairro==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_bairro')" v-if="form.errors.has('tom_bairro')"></b-form-feedback>
                          </b-col>
                          <b-col>
                              <label>Complemento</label>
                              <b-form-input type="text"
                                          placeholder="Complemento"
                                          v-model="form.doc_cte_partes_env.tom_complemento"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_complemento==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_complemento')" v-if="form.errors.has('tom_complemento')"></b-form-feedback>
                          </b-col>
                          </b-row>
                          <b-row>
                            <b-col>
                                <label>Município</label>
                                <b-form-input type="text"
                                            placeholder="Município"
                                            disabled
                                            v-model="form.doc_cte_partes_env.tom_nome_municipio"
                                            name="cst"
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('tom_nome_municipio')" v-if="form.errors.has('tom_nome_municipio')"></b-form-feedback>
                            </b-col>
                          <b-col>
                              <label>UF</label>
                              <b-form-input type="text"
                                          placeholder="UF"
                                          disabled
                                          v-model="form.doc_cte_partes_env.tom_uf"
                                          name="cst"
                                          :disabled="form.doc_cte_partes_env.tom_uf==null"
                                          >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tom_uf')" v-if="form.errors.has('tom_uf')"></b-form-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                        <b-col >
                            <label>Email</label>
                            <b-form-input type="text"
                                        placeholder="Email"
                                        :disabled="form.doc_cte_partes_env.tom_email==null"
                                        v-model="form.doc_cte_partes_env.tom_email"
                                        name="cst"
                                        >
                            </b-form-input>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('tom_email')" v-if="form.errors.has('tom_email')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label>Telefone</label>
                            <b-form-input type="text"
                                        placeholder="Telefone"
                                        :disabled="form.doc_cte_partes_env.tom_telefone==null"
                                        v-model="form.doc_cte_partes_env.tom_telefone"
                                        name="cst"
                                        >
                            </b-form-input>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('tom_telefone')" v-if="form.errors.has('tom_telefone')"></b-form-feedback>
                        </b-col>
                      </b-row>
                  </b-tab>
                          </b-tabs>
                                  </b-tab>
                                  <b-tab title="Carga">
                                    <table class="table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 20%">Unidade de medida*</th>
                                                <th style="width: 20%">Tipo de medida</th>
                                                <th style="width: 20%">Quantidade carga</th>
                                                <th style="width: 10%">Ações</th>
                                            </tr>
                                         </thead>
                                         <tbody>
                                             <tr v-for="(row, index) in carga_medida" class="bg-gray-light" style="display: table-row;">
                                                <td>
                                                  <b-col>
                                                      <multiselect v-model="row.medida"
                                                      :options="optionsParamUnidadeMedida"
                                                      track-by="value"
                                                      label="label"
                                                      :hide-selected="true"
                                                      placeholder="Selecione"
                                                      tag-placeholder="Selecionar"
                                                      select-label="Selecionar"
                                                      selected-label="Selecionado"
                                                      deselect-label="Remover"
                                                      ></multiselect>
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.medida.value')" v-if="form.errors.has('carga_medida.'+index+'.medida.value')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                  <b-col>
                                                      <multiselect v-model="row.tipomedida"
                                                      :options="optionsParamTipoMedida"
                                                      track-by="value"
                                                      label="label"
                                                      :hide-selected="true"
                                                      placeholder="Selecione"
                                                      tag-placeholder="Selecionar"
                                                      select-label="Selecionar"
                                                      selected-label="Selecionado"
                                                      deselect-label="Remover"
                                                      ></multiselect>
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.tipomedida.value')" v-if="form.errors.has('carga_medida.'+index+'.tipomedida.value')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                  <b-col>
                                                    <currency-input
                                                        class="form-control"
                                                        v-model="row.qtde_carga"
                                                        :auto-decimal-mode="true"
                                                        :precision="4"
                                                        placeholder="Vlr."
                                                        :currency="{ prefix: '' }"
                                                        :distraction-free="getCurrency"
                                                    />
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.qtde_carga')" v-if="form.errors.has('carga_medida.'+index+'.qtde_carga')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                      <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCarga(index);"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                  </b-tab>
                                  <b-tab title="Documentos">
                                      <table class="table-striped">
                                          <thead>
                                              <tr>
                                                  <th style="width: 20%">Emitente</th>
                                                  <th style="width: 25%">Chave</th>
                                                  <th style="width: 10%">Número Fiscal</th>
                                                  <th style="width: 10%">Série</th>
                                                  <th style="width: 15%">Data</th>
                                                  <th style="width: 5%">Ação</th>
                                              </tr>
                                           </thead>
                                           <tbody>
                                               <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                                  <td>
                                                      {{ row.emi_nome }}
                                                  </td>
                                                  <td>
                                                      {{ row.chave }}
                                                  </td>
                                                  <td>
                                                      {{ row.num_fiscal }}
                                                  </td>
                                                  <td>
                                                      {{ row.serie }}
                                                  </td>
                                                  <td>
                                                      <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                                  </td>
                                                  <td>

                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </b-tab>
                                  <b-tab title="Seguro">
                                    <table class="table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 45%">Responsável pelo seguro*</th>
                                                <th style="width: 45%">Seguradora</th>
                                                <th style="width: 5%">Ações</th>
                                            </tr>
                                         </thead>
                                         <tbody>
                                             <tr v-for="(row, index) in seguro">
                                                <td>
                                                  <b-col>
                                                      <multiselect v-model="row.respseg"
                                                      :options="optionsParamRespSeg"
                                                      track-by="value"
                                                      label="label"
                                                      :hide-selected="true"
                                                      placeholder="Selecione"
                                                      tag-placeholder="Selecionar"
                                                      select-label="Selecionar"
                                                      selected-label="Selecionado"
                                                      deselect-label="Remover"
                                                      ></multiselect>
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.respseg.value')" v-if="form.errors.has('seguro.'+index+'.respseg.value')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                  <multiselect v-model="row.seguradora"
                                                  :options="optionsSeguradora"
                                                  track-by="value"
                                                  label="label"
                                                  :hide-selected="true"
                                                  placeholder="Selecione"
                                                  tag-placeholder="Selecionar"
                                                  select-label="Selecionar"
                                                  selected-label="Selecionado"
                                                  deselect-label="Remover"
                                                  ></multiselect>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.seguradora.value')" v-if="form.errors.has('seguro.'+index+'.seguradora.value')"></b-form-feedback>
                                                </td>
                                                <td>
                                                    <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSeguro(index);"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </b-tab>
                                  <b-tab title="Observações" >
                                      <h4 class="panel-title">Observação Geral</h4>
                                      <b-form-textarea id="textarea1"
                                                       name="obs"
                                                       v-model="form.obs"
                                                       placeholder="Observação"
                                                       :rows="6"
                                                       :max-rows="6">
                                      </b-form-textarea>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                                      <h4 class="panel-title">Campos livres contribuinte</h4>
                                        <table class="table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 45%">Campo</th>
                                                    <th style="width: 45%">Valor</th>
                                                    <th style="width: 10%">Ações</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                 <tr v-for="(row, index) in obs_cont">
                                                    <td>
                                                      <b-col>
                                                          <b-form-input type="text"
                                                                      placeholder="Descrição"
                                                                      v-model="row.xcampo"
                                                                      >
                                                          </b-form-input>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cont.'+index+'.xcampo')" v-if="form.errors.has('obs_cont.'+index+'.xcampo')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                      <b-col>
                                                          <b-form-input type="text"
                                                                      placeholder="Valor"
                                                                      v-model="row.xtexto"
                                                                      >
                                                          </b-form-input>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cont.'+index+'.xtexto')" v-if="form.errors.has('obs_cont.'+index+'.xtexto')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowObsCont(index);"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <h4 class="panel-title">Campos livres fisco</h4>
                                        <table class="table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 45%">Campo</th>
                                                    <th style="width: 45%">Valor</th>
                                                    <th style="width: 10%">Ações</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                 <tr v-for="(row, index) in obs_fisco">
                                                    <td>
                                                      <b-col>
                                                          <b-form-input type="text"
                                                                      placeholder="Descrição"
                                                                      v-model="row.xcampo"
                                                                      >
                                                          </b-form-input>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco.'+index+'.xcampo')" v-if="form.errors.has('obs_fisco.'+index+'.xcampo')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                      <b-col>
                                                          <b-form-input type="text"
                                                                      placeholder="Valor"
                                                                      v-model="row.xtexto"
                                                                      >
                                                          </b-form-input>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco.'+index+'.xtexto')" v-if="form.errors.has('obs_fisco.'+index+'.xtexto')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowObsFisco(index);"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                  </b-tab>
                                  <b-tab title="Comp. Frete" >
                                    <table class="table-striped">
                                        <thead>
                                            <tr>
                                                <th style="width: 45%">Componentes</th>
                                                <th style="width: 45%">Valor</th>
                                                <th style="width: 10%">Ações</th>
                                            </tr>
                                         </thead>
                                         <tbody>
                                             <tr v-for="(row, index) in comp_frete">
                                                <td>
                                                    <multiselect v-model="row.custo"
                                                    :options="optionsCustos"
                                                    track-by="value"
                                                    label="label"
                                                    :hide-selected="true"
                                                    placeholder="Selecione"
                                                    tag-placeholder="Selecionar"
                                                    select-label="Selecionar"
                                                    selected-label="Selecionado"
                                                    deselect-label="Remover"
                                                    ></multiselect>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.custo.value')" v-if="form.errors.has('comp_frete.'+index+'.custo.value')"></b-form-feedback>
                                                </td>
                                                <td>
                                                  <b-col>
                                                      <currency-input
                                                        class="form-control"
                                                        v-model="row.vlr"
                                                        :auto-decimal-mode="true"
                                                        :precision="4"
                                                        placeholder="Vlr."
                                                        :currency="{ prefix: '' }"
                                                        :distraction-free="getCurrency"
                                                      />
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.vlr')" v-if="form.errors.has('comp_frete.'+index+'.vlr')"></b-form-feedback>
                                                  </b-col>
                                                </td>
                                                <td>
                                                      <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCompFrete(index);"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                  </b-tab>
                                  <b-tab title="Documentos Anteriores" disabled>
                                    <br>Documento Anterior de Transporte
                                  </b-tab>
                                </b-tabs>
                            </b-col>
                          </b-row>
                       </b-container fluid class="p-a-0">
                     </form>

                    <div slot="modal-footer" class="w-100">
                           <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                           <div class="float-right">
                               <b-btn @click="showModalCarta=false" variant="secondary">
                                 Fechar
                               </b-btn>
                               <b-btn @click="handleOkCarta($event)" variant="secondary" :disabled="isDisabled">
                                 Enviar
                               </b-btn>
                           </div>
                       </div>
                    </b-modal>
        </div>
        <ModalImpressaoPorNfe ref="modalimpressaopornfe" />
        <GerarCteComplementarForm
            ref="gerarctecomplementarform">
        </GerarCteComplementarForm>
        <GerarCteAnulacaoForm
            ref="gerarcteanulacaoform">
        </GerarCteAnulacaoForm>
        <GerarCteSubstitutoForm
            ref="gerarctesubstitutoform">
        </GerarCteSubstitutoForm>
        <GerarCteForm
            ref="gerarcteform">
        </GerarCteForm>
        <CtePartesEnvForm
            ref="ctepartesenvform" :metodo="onSaveChanges">
        </CtePartesEnvForm>
        <ModalImprimirEtiqueta ref="modalimprimiretiqueta" />
    </div>
</template>

<script>
import AvisoErros from "../components/AvisoErros";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePaginationWithDropdown";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import CteFilterBar from "./CteFilterBar";
import GerarCteComplementarForm from "./GerarCteComplementarForm";
import GerarCteAnulacaoForm from "./GerarCteAnulacaoForm";
import GerarCteSubstitutoForm from "./GerarCteSubstitutoForm";
import GerarCteForm from "./GerarCteForm";
import CtePartesEnvForm from "./CtePartesEnvForm";
import CteDetalhes from "./CteDetalhes";
import ModalImpressaoPorNfe from "./ModalImpressaoPorNfe.vue";
import ModalImprimirEtiqueta from "./ModalImprimirEtiqueta.vue";
import accounting from "accounting";
import { VMoney } from "v-money";
import moment from "moment";

Vue.component("cte-detalhes", CteDetalhes);

export default {
  components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": CteFilterBar,
    VMoney,
    GerarCteComplementarForm,
    GerarCteAnulacaoForm,
    GerarCteSubstitutoForm,
    CtePartesEnvForm,
    GerarCteForm,
    ModalImpressaoPorNfe,
    ModalImprimirEtiqueta,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      errors_array: [],
      modal_botao: "",
      tp_evento: "",
      loading: false,
      loadingCep: false,
      loadingAddDoc: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalErp: false,
      showModalSubstituto: false,
      showModalAnulacao: false,
      showModalEnviarXmlDacte: false,
      showModalEdit: false,
      showModalComplementar: false,
      showModalCarta: false,
      convert_values: false,
      showPopover: false,
      optionsParamMotivo: [],
      optionsExpedidor: [],
      optionsUf: [],
      optionsRecebedor: [],
      optionsTomador: [],
      optionsLivCfop: [],
      optionsTpDoc: [],
      optionsLivTpServico: [],
      optionsLivGlobalizado: [],
      optionsLivDocFiscalTpDoc: [],
      optionsLivDocTranspTpDoc: [],
      optionsLivTpPessoa: [],
      optionsMunicipios: [],
      isLoadingExp: false,
      isLoadingRec: false,
      isLoadingTom: false,
      isFullscreen: false,
      filter_data_store: {},
      filtros_form: new Form({
        num_fiscal: "",
        chave: "",
        embarcacao_id: "",
        num_viagem: "",
        des_nome: "",
        tom_nome: "",
        des_cnpj: "",
        tom_cnpj: "",
        rem_nome: "",
        rem_cnpj: "",
        rec_nome: "",
        rec_cnpj: "",
        recebedor: "",
        status_sefaz: "",
        status_doc: "",
        porto_embarque: "",
        porto_destino: "",
        municipio_inicio: "",
        municipio_fim: "",
        dt_inicio: "",
        hr_inicio: "",
        dt_fim: "",
        hr_fim: "",
        modal: "",
        averbado: "",
        consulta_completa: "",
        usuario_inc: "",
        num_nf: "",
        tp_doc: "",
      }),
      helpForm: new Form({
        statusRecord: [],
        mensageriaRecord: [],
        params: [],
        search: "",
        docs: [],
        chave: "",
        emi_tp_pessoa: [],
        emi_cnpj_cpf_cuit: "",
        emi_ie: "",
        emi_nome: "",
        emi_cep: "",
        emi_numero: "",
        emi_bairro: "",
        emi_endereco: "",
        emi_municipio: [],
        emi_complemento: "",
        des_tp_pessoa: [],
        des_cnpj_cpf_cuit: "",
        des_nome: "",
        des_cep: "",
        des_numero: "",
        des_bairro: "",
        des_endereco: "",
        des_municipio: [],
        des_complemento: "",
        des_pin: "",
        tp_doc: [],
        num_fiscal: "",
        serie: "",
        dt_emissao: "",
        qtd_volume: "",
        peso_bruto: 0,
        vlr_total_nfe: 0,
        cep_busca: "",
      }),
      form_doctransp: new Form({
        doctransp: [],
        chave: "",
        emi_cnpj_cpf_cuit: "",
        emi_ie: "",
        emi_nome: "",
        emi_cep: "",
        emi_numero: "",
        emi_bairro: "",
        emi_endereco: "",
        emi_municipio: [],
        emi_complemento: "",
        des_tp_pessoa: [],
        des_cnpj_cpf_cuit: "",
        des_nome: "",
        des_cep: "",
        des_numero: "",
        des_bairro: "",
        des_endereco: "",
        des_municipio: [],
        des_complemento: "",
        des_pin: "",
        tp_doc: [],
        num_fiscal: "",
        serie: "",
        dt_emissao: "",
        qtd_volume: "",
        peso_bruto: 0,
        vlr_total_cte: 0,
        cep_busca: "",
      }),
      vlr_total: 0,
      vn_vlr_cte: 0,
      vn_aliquota: 0,
      vn_percentual_reducao_bc: 0,
      activateDesativate: [],
      optionsMunicipioIni: [],
      optionsMunicipioFim: [],
      optionsPortoOrigem: [],
      optionsPortoTransbordo: [],
      optionsPortoDestino: [],
      optionsParamCst: [],
      optionsEmbarcacao: [],
      optionsParamUnidadeMedida: [],
      optionsParamTipoMedida: [],
      optionsParamRespSeg: [],
      optionsSeguradora: [],
      optionsCustos: [],
      obs_cont: [],
      doc_cte_partes_env: [],
      obs_fisco: [],
      doctadobs_id: "",
      docfis: [],
      docfisDig: [],
      doctransp: [],
      doctranspDig: [],
      errors_array: [],
      carga_medida: [
        {
          medida: [],
          tipomedida: [],
          qtde_carga: 0,
          doc_cte_id: "",
          docctecar_id: "",
        },
      ],
      seguro: [
        {
          partprese_id: [],
          seguradora: [],
          segurado_id: "",
          respseg: [],
          docteseg_id: [],
        },
      ],
      comp_frete: [
        {
          nome: "",
          custo: [],
          doctcofrt_id: "",
          vlr: 0,
        },
      ],
      vlr: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      percentual_reducao_bc: {
        decimal: ",",
        thousands: ".",
        prefix: "% ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      aliquota: {
        decimal: ",",
        thousands: ".",
        prefix: "% ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      qtd: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 3,
        masked: false /* doesn't work with directive */,
      },
      formdoc: new Form({
        doc_id: [],
        doccte_id: "",
        tp_evento: "",
        motivo: [],
        obs: "",
        status: [],
      }),
      form_mensageria: new Form({
        doc_id: "",
      }),
      formimprimir: new Form({
        doc_id: "",
        doc_id_pdf: [],
        doccte_id: "",
        docrps_id: "",
        tp_doc: "",
        tp_print: "",
      }),
      formreenviaritrack: new Form({
        doc_id: "",
      }),
      form_enviar_xml: new Form({
        doccte_id: "",
        email: "",
      }),
      formimprimircarta: new Form({
        carcor_id: "",
      }),
      formerp: new Form({
        doctpaen_id: "",
        tipo_erp: "",
        cd: "",
      }),
      formchave: new Form({
        chave: "",
      }),
      form: new Form({
        tp_orig_doc: 1,
        cst: "",
        chave_cte_multi: "",
        cfop: [],
        cfop_id: "",
        parcst_id: "",
        rntrc: "",
        tp_servico: [],
        tp_cte: 0,
        municipio_id_ini: "",
        municipio_id_fim: "",
        municipio_ini: [],
        municipio_fim: [],
        produto_predominante: "",
        vlr_cte: "",
        vlr_aliquota: 0,
        vlr_imposto: 0,
        vlr_total: 0,
        vlr_carga: 0,
        percentual_reducao_bc: 0,
        porto_origem: [],
        porto_transbordo: [],
        porto_destino: [],
        embarcacao: [],
        expedidor: "",
        recebedor: "",
        tomador_outros: "",
        num_viagem: "",
        recebedor: [],
        expedidor: [],
        tomador: "",
        tomador_outros: [],
        obs: "",
        obs_carta: "",
        vlr_aliquota_afrmm: "",
        modal: "",
        doc_id: "",
        doccte_id: "",
        carga_medida: [],
        seguro: [],
        docfis: [],
        doctransp: [],
        obs_cont: [],
        obs_fisco: [],
        comp_frete: [],
        doc_cte_partes_env: [],
        doctranspDig: [],
        docfisDig: [],
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_controle",
          title: "Nº Controle",
        },
        {
          name: "num_fiscal",
          title: "Nº Fiscal",
        },
        {
          name: "serie",
          title: "Série",
        },
        {
          name: "vlr_prestacao",
          title: "Valor",
          callback: "formatNumber",
        },
        {
          name: "dt_emi",
          title: "Data de Emissão",
          callback: "formatDate|DD/MM/YYYY HH:mm",
        },
        {
          name: "__slot:remetente",
          title: "Remetente",
        },
        {
          name: "__slot:tp_processo",
          title: "Processo",
        },
        {
          name: "__slot:tp_operacao",
          title: "Operação",
        },
        {
          name: "b_modal.descr",
          title: "Modal",
        },
        {
          name: "doc_cte.tp_servico.descr",
          title: "Tipo Serviço",
        },
        {
          name: "__slot:tp_doc",
          title: "Tipo",
        },
        {
          name: "__slot:tp_evento",
          title: "Evento",
        },
        {
          name: "__slot:status",
          title: "Status Doc",
        },
        {
          name: "__slot:status_sefaz",
          title: "Status Sefaz",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
    };
  },
  directives: {
    aliquota: VMoney,
    qtd: VMoney,
    vlr: VMoney,
    percentual_reducao_bc: VMoney,
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    // Event.$on('printCarta', function(carcor_id) {
    //     self.onPrintCarta(carcor_id, null);
    // });
    // Event.$on('enviarxmldacte', function(doccte_id) {
    //     self.onCreateEnviarXmlDacte(doccte_id);
    // });
    // Event.$on('alterarcderp', function(doctpaen_id, tipo_erp) {
    //     self.onAlterarCdErp(doctpaen_id, tipo_erp);
    // });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    formatDate(value, fmt = "D MMM YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 4, ",", ".");
    },
    formatNumberCarga(value) {
      return accounting.formatNumber(value, 3, ".", ",");
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_fiscal: data_filter.num_fiscal,
        dt_inicio: data_filter.dt_inicio,
        hr_inicio: data_filter.hr_inicio,
        dt_fim: data_filter.dt_fim,
        hr_fim: data_filter.hr_fim,
        chave: data_filter.chave,
        averbado: data_filter.averbado,
        consulta_completa: data_filter.consulta_completa,
        usuario_inc: data_filter.usuario_inc,
        num_nf: data_filter.num_nf,
        embarcacao_id: data_filter.embarcacao_id,
        num_viagem: data_filter.num_viagem,
        status_sefaz: data_filter.status_sefaz.value,
        status_doc: data_filter.status_doc.value,
        porto_embarque: data_filter.porto_embarque.value,
        porto_destino: data_filter.porto_destino.value,
        municipio_inicio: data_filter.municipio_inicio.value,
        municipio_fim: data_filter.municipio_fim.value,
        tp_operacao: data_filter.tp_operacao.value,
        tp_processo: data_filter.tp_processo.value,
        des_nome: data_filter.des_nome,
        tom_nome: data_filter.tom_nome,
        des_cnpj: data_filter.des_cnpj,
        tom_cnpj: data_filter.tom_cnpj,
        rem_nome: data_filter.rem_nome,
        rem_cnpj: data_filter.rem_cnpj,
        rec_nome: data_filter.rec_nome,
        rec_cnpj: data_filter.rec_cnpj,
        recebedor: data_filter.recebedor.pessoa_id,
        tp_doc: data_filter.tp_doc.value,
        modal: data_filter.modal.value,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
        // this.onCreateDoc(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onSaveChanges() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.reload());
    },
    searchAll(data_filter, tipo) {
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.num_fiscal = this.filter_data_store.num_fiscal;
          this.filtros_form.chave = this.filter_data_store.chave;
          this.filtros_form.embarcacao_id =
            this.filter_data_store.embarcacao_id;
          this.filtros_form.num_viagem = this.filter_data_store.num_viagem;
          this.filtros_form.des_nome = this.filter_data_store.des_nome;
          this.filtros_form.tom_nome = this.filter_data_store.tom_nome;
          this.filtros_form.des_cnpj = this.filter_data_store.des_cnpj;
          this.filtros_form.tom_cnpj = this.filter_data_store.tom_cnpj;
          this.filtros_form.rem_nome = this.filter_data_store.rem_nome;
          this.filtros_form.rem_cnpj = this.filter_data_store.rem_cnpj;
          this.filtros_form.rec_nome = this.filter_data_store.rec_nome;
          this.filtros_form.rec_cnpj = this.filter_data_store.rec_cnpj;
          this.filtros_form.recebedor = this.filter_data_store.recebedor;
          this.filtros_form.status_sefaz = this.filter_data_store.status_sefaz;
          this.filtros_form.status_doc = this.filter_data_store.status_doc;
          this.filtros_form.porto_embarque =
            this.filter_data_store.porto_embarque;
          this.filtros_form.porto_destino =
            this.filter_data_store.porto_destino;
          this.filtros_form.municipio_inicio =
            this.filter_data_store.municipio_inicio;
          this.filtros_form.municipio_fim =
            this.filter_data_store.municipio_fim;
          this.filtros_form.dt_inicio = this.filter_data_store.dt_inicio;
          this.filtros_form.hr_inicio = this.filter_data_store.hr_inicio;
          this.filtros_form.dt_fim = this.filter_data_store.dt_fim;
          this.filtros_form.hr_fim = this.filter_data_store.hr_fim;
          this.filtros_form.modal = this.filter_data_store.modal;
          this.filtros_form.averbado = this.filter_data_store.averbado;
          this.filtros_form.consulta_completa =
            this.filter_data_store.consulta_completa;
          this.filtros_form.usuario_inc = this.filter_data_store.usuario_inc;
          this.filtros_form.num_nf = this.filter_data_store.num_nf;
          this.filtros_form.tp_doc = this.filter_data_store.tp_doc;
          this.filtros_form
            .post("/api/cte/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onPrintCarta(carcor_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimircarta.carcor_id = carcor_id;
      this.formimprimircarta
        .post("/api/cte/printcarta")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onImprimirXml(doc_id, tp_print, tp_doc) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doc_id_pdf = [];
      if (tp_print == 2 || tp_print == 3) {
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.formimprimir.doc_id_pdf.push({
            id: obj,
          });
        });
      } else if (tp_print == 1) {
        this.formimprimir.doc_id_pdf.push({
          id: doc_id,
          tp_doc: tp_doc,
        });
      }
      this.formimprimir.tp_print = tp_print;

      this.loading = true;
      this.isDisabled = true;
      this.formimprimir
        .post("/api/cte/imprimircte")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onImprimirRps(data, tp_doc) {
      this.loading = true;
      this.isDisabled = true;
      console.log(data);
      this.formimprimir.doc_id = data;
      this.formimprimir.tp_doc = tp_doc;
      this.formimprimir
        .post("/api/cte/imprimirps")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
        });
    },
    onImprimirEtiqueta() {
      this.$refs.modalimprimiretiqueta.onCreate();
    },
    onDownloadXmlLote() {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doccte_id = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.formimprimir.doccte_id.push({
          id: obj,
        });
      });
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir
        .post("/api/cte/downloadxmllote")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onDownloadXml(doccte_id, docrps_id) {
      this.loading = true;
      this.isDisabled = true;
      this.formimprimir.doccte_id = doccte_id;
      this.formimprimir.docrps_id = docrps_id;
      this.formimprimir
        .post("/api/cte/downloadxml")
        .then((response) => {
          new ReturnApi(response, this, true, null, null, false);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onImprimirPorNfe() {
      this.$refs.modalimpressaopornfe.onCreate();
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.doc_id);
    },
    handleAcaoDoc(e) {
      this.loading = true;
      this.isDisabled = true;
      this.formdoc.tp_evento = this.tp_evento;
      this.formdoc.status = this.form.status;
      this.formdoc
        .post("/api/cte/evento")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    handleOkCarta(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStoreCarta();
      }
    },
    onCreateCarta(data) {
      this.modal_titulo = "Gerar Carta";
      this.modal_botao = "Gerar Carta";
      this.modal_acao = "i";
      this.isDisabled = false;
      this.form.reset();
      this.data = data;
      this.form.doc_cte = data.doc_cte;
      this.form.doc_cte_partes_env = data.doc_cte_partes_env;
      this.form.doccte_id = data.doccte_id;
      this.form.produto_predominante =
        data.doc_cte.doc_cte_adicional.produto_predominante;
      this.form.vlr_carga = this.formatNumber(
        data.doc_cte.doc_cte_adicional.vlr_carga
      );
      this.form.obs = data.doc_cte.doc_cte_adicional.observacao_geral;
      this.obs_cont = null;
      this.obs_cont = [];
      data.doc_cte.doc_cte_adicional.doc_cte_adicional_obs.forEach((obj) => {
        this.obs_cont.push({
          xcampo: obj.campo,
          xtexto: obj.texto,
          doctadobs_id: obj.doctadobs_id,
        });
      });
      this.obs_fisco = null;
      this.obs_fisco = [];
      data.doc_cte.doc_cte_adicional.doc_cte_adicional_fluxo.forEach((obj) => {
        this.obs_cont.push({
          xcampo: obj.campo,
          xtexto: obj.texto,
        });
      });
      this.carga_medida = null;
      this.carga_medida = [];
      data.doc_cte.doc_cte_carga.forEach((obj) => {
        this.carga_medida.push({
          qtde_carga: obj.qtd,
          docctecar_id: obj.docctecar_id,
          medida: {
            label: obj.param_unidade_medida.descr,
            value: obj.param_unidade_medida.parunidmed_id,
          },
          tipomedida: {
            label: obj.param_tipo_medida.descr,
            value: obj.param_tipo_medida.partpmed_id,
          },
        });
      });
      this.comp_frete = null;
      this.comp_frete = [];
      data.doc_cte.doc_cte_comp_frete.forEach((obj) => {
        this.comp_frete.push({
          custo: {
            label: obj.custo.descr + " - " + obj.custo.cd,
            value: obj.custo.custo_id,
          },
          vlr: obj.vlr,
          doctcofrt_id: obj.doctcofrt_id,
        });
      });
      this.seguro = null;
      this.seguro = [];
      data.doc_cte.doc_cte_seguro.forEach((obj) => {
        this.seguro.push({
          respseg: {
            label: obj.param_tipo_resp_seg.descr,
            value: obj.param_tipo_resp_seg.cd,
          },
          seguradora: {
            label: obj.seguradora.descr,
            value: obj.seguradora.cd,
          },
          segurado_id: obj.seguradora.segurado_id,
          nome: obj.seguradora.nome,
          docteseg_id: obj.docteseg_id,
          partprese_id: obj.param_tipo_resp_seg.partprese_id,
        });
      });
      this.form.doc_id = data.doc_id;
      this.$refs.modal_form_carta.show();
    },
    onStoreCarta() {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_medida = this.carga_medida;
      this.form.comp_frete = this.comp_frete;
      this.form.obs_cont = this.obs_cont;
      this.form.obs_fisco = this.obs_fisco;
      this.form.seguro = this.seguro;
      this.form
        .post("/api/cte/carta/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onCreateComplementar(modal) {
      this.$refs.gerarctecomplementarform.onCreate(modal);
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStoreErp();
      } else {
        this.onUpdate(e);
      }
    },
    handleOkCdErp(e) {
      e.preventDefault();
      this.onStoreErp();
    },
    onCteSubstituto(doc_id, tomador) {
      this.$refs.gerarctesubstitutoform.onCreate(doc_id, tomador);
    },
    onCreateCteAnulacao(doc_id) {
      this.$refs.gerarcteanulacaoform.onCreate(doc_id);
    },
    onAlterarCdErp(doctpaen_id, tipo_erp, data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_acao = "i";
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.formerp.tipo_erp = tipo_erp;
      this.formerp.doctpaen_id = doctpaen_id;
      this.$refs.modal_form_cderp.show();
    },
    onCreateEnviarXmlDacte(doccte_id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_acao = "i";
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.form_enviar_xml.doccte_id = doccte_id;
      this.$refs.modal_form_enviar_xml_dacte.show();
    },
    handleOkEnviarXmlDacte(e) {
      e.preventDefault();
      this.onStoreEnviarXmlDacte();
    },
    onEdit(data) {
      this.$refs.ctepartesenvform.onEdit(data);
    },
    onStoreErp() {
      this.loading = true;
      this.isDisabled = true;
      this.formerp
        .post("/api/cte/storeerp")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onStoreEnviarXmlDacte() {
      this.loading = true;
      this.isDisabled = true;
      this.form_enviar_xml
        .post("/api/cte/store/xml_dacte")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdate(e) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_medida = this.carga_medida;
      this.form.seguro = this.seguro;
      this.form.obs_cont = this.obs_cont;
      this.form.obs_fisco = this.obs_fisco;
      this.form.comp_frete = this.comp_frete;
      this.form.docfis = this.docfis;
      this.form.docfisDig = this.docfisDig;
      this.form.doctransp = this.doctransp;
      this.form.doctranspDig = this.doctranspDig;
      this.form.cfop_id = this.form.cfop.value;
      this.form.parcst_id = this.form.cst.value;
      this.form.municipio_id_ini = this.form.municipio_ini.value;
      this.form.municipio_id_fim = this.form.municipio_fim.value;
      this.form
        .post("/api/cte/update")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onAcaoDoc(tp_evento) {
      if (tp_evento == "3") {
        this.modal_titulo = "Inutilizar CTE(s)";
        this.modal_botao = "Inutilizar CTE(s)";
      } else if (tp_evento == "2") {
        this.modal_titulo = "Cancelar CTE(s)";
        this.modal_botao = "Cancelar CTE(s)";
      }
      this.errors_array = "";
      this.errors_array = [];
      this.tp_evento = tp_evento;
      this.loading = false;
      this.isDisabled = false;
      this.formdoc.reset();
      this.formdoc.doc_id = [];
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.formdoc.doc_id.push({
          id: obj,
        });
      });
      this.$refs.modal_form.show();
    },
    onStatusMensageria(data, tipo) {
      this.helpForm.mensageriaRecord = "";
      this.helpForm.mensageriaRecord = [];
      let form = this.helpForm;
      var vm = this;
      if (data !== null) {
        var doc_id = data.doc_id;
      }
      var tipo = tipo;

      const onConfirmUnitWrapper = () => {
        confirmPresenca(vm, doc_id, tipo);
      };

      let confirmPresenca = function (vm, doc_id, tipo) {
        // Tipo = true = Checkbox
        if (tipo) {
          vm.helpForm.mensageriaRecord = [];
          vm.helpForm.mensageriaRecord.push({
            id: doc_id,
          });
        } else {
          vm.helpForm.mensageriaRecord = [];
          vm.$refs.vuetable.selectedTo.forEach((obj) => {
            vm.helpForm.mensageriaRecord.push({
              id: obj,
            });
          });
        }

        vm.helpForm
          .post("/api/cte/status/mensageria")
          .then((response) => {
            new ReturnApi(response, vm);
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
          });
      };
      if (data !== null) {
        var vv_descr_num = data.num_controle;
      } else {
        var vv_descr_num = "selecionado(s)";
      }
      let obj = {
        title: "Reenviar Mensageria ?",
        message:
          "Você deseja reenviar a mensageria para o(s) documento(s) " +
          vv_descr_num +
          " ?",
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      this.$Simplert.open(obj);
    },
    calcCte() {
      this.vn_vlr_cte = this.form.vlr_cte.replace(".", "");
      this.vn_vlr_cte = this.vn_vlr_cte.replace(",", ".");
      this.vn_vlr_cte = parseFloat(this.vn_vlr_cte.replace(/[^0-9.]/g, ""));

      this.vn_aliquota = this.form.vlr_aliquota.replace(".", "");
      this.vn_aliquota = this.vn_aliquota.replace(",", ".");
      this.vn_aliquota = parseFloat(this.vn_aliquota.replace(/[^0-9.]/g, ""));
      this.form.vlr_imposto = Number(
        this.vn_vlr_cte / ((100 - this.vn_aliquota) / 100) - this.vn_vlr_cte
      ).toFixed(2);
      this.vn_vlr_total =
        parseFloat(this.vn_vlr_cte) + parseFloat(this.form.vlr_imposto);
      this.form.vlr_total = Number(this.vn_vlr_total).toFixed(2);
    },
    getLivGeral() {
      this.helpForm
        .get("/api/cte/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.param_cst.forEach((obj) => {
            this.optionsParamCst.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.parcst_id,
              cd: obj.cd,
            });
          });

          response.cfops.forEach((obj) => {
            this.optionsLivCfop.push({
              label: obj.cd + " - " + obj.descr,
              value: obj.cfop_id,
            });
          });

          response.tp_servico.forEach((obj) => {
            this.optionsLivTpServico.push({
              label: obj.valor + " - " + obj.descr,
              value: obj.valor,
            });
          });

          response.uf.forEach((obj) => {
            this.optionsUf.push({
              label: obj.cd,
              value: obj.cd,
            });
          });

          response.municipios.forEach((obj) => {
            this.optionsMunicipioIni.push({
              label: obj.nome + " - " + obj.cd_ibge,
              value: obj.municipio_id,
            });
            this.optionsMunicipioFim.push({
              label: obj.nome + " - " + obj.cd_ibge,
              value: obj.municipio_id,
            });
            this.optionsMunicipios.push({
              label: obj.nome,
              ibge: obj.cd_ibge,
              value: obj.municipio_id,
            });
          });
          response.portos.forEach((obj) => {
            this.optionsPortoOrigem.push({
              label: obj.nome + " - " + obj.cd,
              value: obj.porto_id,
            });
            this.optionsPortoTransbordo.push({
              label: obj.nome + " - " + obj.cd,
              value: obj.porto_id,
            });
            this.optionsPortoDestino.push({
              label: obj.nome + " - " + obj.cd,
              value: obj.porto_id,
            });
          });
          response.embarcacao.forEach((obj) => {
            this.optionsEmbarcacao.push({
              label: obj.nome + " - " + obj.irin,
              value: obj.embarcacao_id,
            });
          });
          response.medida.forEach((obj) => {
            this.optionsParamUnidadeMedida.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.parunidmed_id,
            });
          });
          response.tipomedida.forEach((obj) => {
            this.optionsParamTipoMedida.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.partpmed_id,
            });
          });
          response.respseg.forEach((obj) => {
            this.optionsParamRespSeg.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.partprese_id,
            });
          });
          response.seguradora.forEach((obj) => {
            this.optionsSeguradora.push({
              label: obj.nome + " - " + obj.apolice,
              value: obj.segurado_id,
            });
          });
          response.custos.forEach((obj) => {
            this.optionsCustos.push({
              label: obj.descr + " - " + obj.cd,
              value: obj.custo_id,
            });
          });

          response.globalizado.forEach((obj) => {
            this.optionsLivGlobalizado.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.doc_fiscal_tp_doc.forEach((obj) => {
            this.optionsLivDocFiscalTpDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.doc_transp_tp_doc.forEach((obj) => {
            this.optionsLivDocTranspTpDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_pessoa.forEach((obj) => {
            this.optionsLivTpPessoa.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.param_motivo.forEach((obj) => {
            this.optionsParamMotivo.push({
              label: obj.descr,
              value: obj.parmot_id,
            });
          });

          response.tp_doc.forEach((obj) => {
            this.optionsTpDoc.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaClientesExpedidor(search) {
      if (search.length >= 3) {
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsExpedidor = [];
            new ReturnApi(response, this, true, false, false);
            this.isLoadingExp = true;
            response.items.forEach((obj) => {
              this.optionsExpedidor.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingExp = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesRecebedor(search) {
      if (search.length >= 3) {
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsRecebedor = [];
            new ReturnApi(response, this, true, false, false);
            this.isLoadingRec = true;
            response.items.forEach((obj) => {
              this.optionsRecebedor.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingRec = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesTomador(search) {
      if (search.length >= 3) {
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsTomador = [];
            new ReturnApi(response, this, true, false, false);
            this.isLoadingTom = true;
            response.items.forEach((obj) => {
              this.optionsTomador.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingTom = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;

      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    addRowCompFrete: function (e) {
      e.preventDefault();
      this.comp_frete.push({
        custo: [],
        vlr: 0,
      });
    },
    removeRowCompFrete: function (index) {
      this.comp_frete.splice(index, 1);
    },
    addRowObsCont: function (e) {
      e.preventDefault();
      this.obs_cont.push({
        xcampo: "",
        xtexto: "",
      });
    },
    removeRowObsCont: function (index) {
      this.obs_cont.splice(index, 1);
    },
    addRowObsFisco: function (e) {
      e.preventDefault();
      this.obs_fisco.push({
        xcampo: "",
        xtexto: "",
      });
    },
    removeRowObsFisco: function (index) {
      this.obs_fisco.splice(index, 1);
    },
    addRowSeguro: function (e) {
      e.preventDefault();
      this.seguro.push({
        seguradora: [],
        partprese: [],
      });
    },
    removeRowSeguro: function (index) {
      this.seguro.splice(index, 1);
    },
    addRowCarga: function (e) {
      e.preventDefault();
      this.carga_medida.push({
        partpmed: [],
        parunidmed: [],
        qtde_carga: 0,
      });
    },
    removeRowCarga: function (index) {
      this.carga_medida.splice(index, 1);
    },
    removeRowDoc: function (index) {
      this.docfis.splice(index, 1);
    },
    addDoc() {
      this.loadingAddDoc = true;
      this.isDisabledAddDoc = true;
      this.helpForm.docs = this.docfis;
      this.helpForm.dt_emissao = this.formatDateSubmit(
        this.helpForm.dt_emissao
      );
      this.helpForm
        .post("/api/associar/adddoc")
        .then((response) => {
          this.docfis.push({
            id: response.docfis_id,
            chave: response.chave,
            num_fiscal: response.num_fiscal,
            serie: response.serie,
            dt_emissao: response.dt_emissao,
            emi_nome: response.doc_fiscal_partes_env.emi_nome,
            emi_cnpj: response.doc_fiscal_partes_env.emi_cnpj,
            des_nome: response.doc_fiscal_partes_env.des_nome,
            des_cnpj: response.doc_fiscal_partes_env.des_cnpj,
            tp_doc: response.liv_tp_doc,
            tp_doc_descr: response.liv_tp_doc.label,
          });
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          new ReturnApi(errors, this);
        });
    },
    addDocDigitacao() {
      this.loadingAddDoc = true;
      this.isDisabledAddDoc = true;
      this.helpForm.docs = this.docfis;
      // Ajustar para adicionar CTE's globalizados #REVISAR#
      // Chamada backend para validar
      this.helpForm.dt_emissao = this.formatDateSubmit(
        this.helpForm.dt_emissao
      );
      this.helpForm
        .post("/api/associar/adddocdigitacao")
        .then((response) => {
          this.docfisDig.push({
            emi_tp_pessoa: this.helpForm.emi_tp_pessoa,
            emi_cnpj_cpf_cuit: this.helpForm.emi_cnpj_cpf_cuit,
            emi_ie: this.helpForm.emi_ie,
            emi_nome: this.helpForm.emi_nome,
            emi_cep: this.helpForm.emi_cep,
            emi_numero: this.helpForm.emi_numero,
            emi_bairro: this.helpForm.emi_bairro,
            emi_endereco: this.helpForm.emi_endereco,
            emi_municipio: this.helpForm.emi_municipio,
            emi_complemento: this.helpForm.emi_complemento,
            des_tp_pessoa: this.helpForm.des_tp_pessoa,
            des_cnpj_cpf_cuit: this.helpForm.des_cnpj_cpf_cuit,
            des_nome: this.helpForm.des_nome,
            des_cep: this.helpForm.des_cep,
            des_numero: this.helpForm.des_numero,
            des_bairro: this.helpForm.des_bairro,
            des_endereco: this.helpForm.des_endereco,
            des_municipio: this.helpForm.des_municipio,
            des_complemento: this.helpForm.des_complemento,
            tp_doc: this.helpForm.tp_doc,
            tp_doc_descr: this.helpForm.tp_doc.label,
            chave: this.helpForm.chave,
            num_fiscal: this.helpForm.num_fiscal,
            serie: this.helpForm.serie,
            dt_emissao: this.helpForm.dt_emissao,
            qtd_volume: this.helpForm.qtd_volume,
            peso_bruto: this.helpForm.peso_bruto,
            vlr_total_nfe: this.helpForm.vlr_total_nfe,
          });

          this.loadingAddDoc = false;

          this.helpForm.reset();
          this.isDisabledAddDoc = false;
          vm.$snotify.success(response.message, response.title);
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
          new ReturnApi(errors, this);
        });
    },
    addDocTransp() {
      this.loading = true;
      this.isDisabled = true;
      this.form_doctransp.doctransp = this.doctransp;
      this.form_doctransp.dt_emissao = this.formatDateSubmit(
        this.form_doctransp.dt_emissao
      );
      this.form_doctransp
        .post("/api/gerarcte/adddoctransp")
        .then((response) => {
          this.doctransp.push({
            id: response.doctransp_id,
            chave: response.chave,
            num_fiscal: response.num_doc,
            serie: response.serie,
            dt_emissao: response.dt_emissao,
            emi_nome: response.doc_transp_partes_env.emi_nome,
            emi_cnpj: response.doc_transp_partes_env.emi_cnpj,
            des_nome: response.doc_transp_partes_env.des_nome,
            des_cnpj: response.doc_transp_partes_env.des_cnpj,
            tp_doc: response.liv_tp_doc,
            tp_doc_descr: response.liv_tp_doc.label,
          });
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    addDocTranspDigitacao() {
      this.loadingAddDoc = true;
      this.isDisabledAddDoc = true;
      this.form_doctransp.doctransp = this.doctranspDig;
      // Chamada backend para validar
      this.form_doctransp.dt_emissao = this.formatDateSubmit(
        this.form_doctransp.dt_emissao
      );
      this.form_doctransp
        .post("/api/associar/adddoctranspdigitacao")
        .then((response) => {
          this.doctranspDig.push({
            emi_cnpj_cpf_cuit: this.form_doctransp.emi_cnpj_cpf_cuit,
            emi_nome: this.form_doctransp.emi_nome,
            emi_cep: this.form_doctransp.emi_cep,
            emi_numero: this.form_doctransp.emi_numero,
            emi_bairro: this.form_doctransp.emi_bairro,
            emi_endereco: this.form_doctransp.emi_endereco,
            emi_municipio: this.form_doctransp.emi_municipio,
            emi_complemento: this.form_doctransp.emi_complemento,
            des_tp_pessoa: this.form_doctransp.des_tp_pessoa,
            des_cnpj_cpf_cuit: this.form_doctransp.des_cnpj_cpf_cuit,
            des_nome: this.form_doctransp.des_nome,
            des_cep: this.form_doctransp.des_cep,
            des_numero: this.form_doctransp.des_numero,
            des_bairro: this.form_doctransp.des_bairro,
            des_endereco: this.form_doctransp.des_endereco,
            des_municipio: this.form_doctransp.des_municipio,
            des_complemento: this.form_doctransp.des_complemento,
            des_pin: this.form_doctransp.des_pin,
            tp_doc: this.form_doctransp.tp_doc,
            tp_doc_descr: this.form_doctransp.tp_doc.label,
            chave: this.form_doctransp.chave,
            num_fiscal: this.form_doctransp.num_fiscal,
            serie: this.form_doctransp.serie,
            dt_emissao: this.form_doctransp.dt_emissao,
            qtd_volume: this.form_doctransp.qtd_volume,
            peso_bruto: this.form_doctransp.peso_bruto,
            vlr_total_cte: this.form_doctransp.vlr_total_cte,
          });

          this.loadingAddDoc = false;

          this.form_doctransp.reset();
          this.isDisabledAddDoc = false;
          vm.$snotify.success(response.message, response.title);
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          this.loadingAddDoc = false;
          this.isDisabledAddDoc = false;
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    removeRowDoc: function (index) {
      this.docfis.splice(index, 1);
    },
    removeRowDocDig: function (index) {
      this.docfisDig.splice(index, 1);
    },
    removeRowDocTransp: function (index) {
      this.doctransp.splice(index, 1);
    },
    removeRowDocTranspDig: function (index) {
      this.doctranspDig.splice(index, 1);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    formatTypedDate: function (dateString) {
      let result = dateString.split("/");
      return result[2] + "-" + result[1] + "-" + result[0] + "T00:00:00-03:00";
    },
    getCep(en_tipo) {
      if (en_tipo == 1) {
        this.helpForm.cep_busca = this.helpForm.emi_cep;
      } else if (en_tipo == 2) {
        this.helpForm.cep_busca = this.helpForm.des_cep;
      } else if (en_tipo == 3) {
        this.helpForm.cep_busca = this.form_doctransp.emi_cep;
      } else if (en_tipo == 4) {
        this.helpForm.cep_busca = this.form_doctransp.des_cep;
      }

      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");

      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              if (en_tipo == 1) {
                this.helpForm.errors.clear();
                response.forEach((obj) => {
                  this.helpForm.emi_endereco = obj.logradouro;
                  this.helpForm.emi_bairro = obj.bairro;
                  this.helpForm.emi_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.helpForm.emi_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 2) {
                this.helpForm.errors.clear();
                response.forEach((obj) => {
                  this.helpForm.des_endereco = obj.logradouro;
                  this.helpForm.des_bairro = obj.bairro;
                  this.helpForm.des_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.helpForm.des_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 3) {
                this.form_doctransp.errors.clear();
                response.forEach((obj) => {
                  this.form_doctransp.emi_endereco = obj.logradouro;
                  this.form_doctransp.emi_bairro = obj.bairro;
                  this.form_doctransp.emi_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.form_doctransp.emi_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              } else if (en_tipo == 4) {
                this.form_doctransp.errors.clear();
                response.forEach((obj) => {
                  this.form_doctransp.des_endereco = obj.logradouro;
                  this.form_doctransp.des_bairro = obj.bairro;
                  this.form_doctransp.des_complemento = obj.complemento;
                  this.optionsMunicipios.forEach((obj2) => {
                    if (obj2.ibge == obj.ibge) {
                      this.form_doctransp.des_municipio = {
                        label: obj2.label,
                        value: obj2.value,
                      };
                    }
                  });
                });
              }
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          if (en_tipo == 1) {
            var errors = {
              errors: {
                emi_cep: ["Cep inválido"],
              },
            };
            this.helpForm.errors.record(errors.errors);
          } else if (en_tipo == 2) {
            var errors = {
              errors: {
                des_cep: ["Cep inválido"],
              },
            };
            this.helpForm.errors.record(errors.errors);
          } else if (en_tipo == 3) {
            var errors = {
              errors: {
                emi_cep: ["Cep inválido"],
              },
            };
            this.form_doctransp.errors.record(errors.errors);
          } else if (en_tipo == 4) {
            var errors = {
              errors: {
                des_cep: ["Cep inválido"],
              },
            };
            this.form_doctransp.errors.record(errors.errors);
          }
        }
      }
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    casasDecimais: {
      get() {
        return this.$store.getters.casas_decimais;
      },
    },
  },
};
</script>
